import { useMutation } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import {
  ExecutePayoutsPayload,
  ExecutePayoutsResponse,
  GetAllPaymentsResponse,
} from './types';

export const createPaymentRequest = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequest`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createPaymentRequestCash = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequest/cash`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
export const createPaymentRequestPassive = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequestPassive`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getCompanyPayoutGroup = async (
  dispatch: Dispatch,
  source: string,
  sourceId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/payout/group/${source}/${sourceId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const reversePaymentRequest = async (
  dispatch: Dispatch,
  sourceId: number,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/company/payouts/payment-request/${sourceId}/reverse`,
    dispatch,
  });
  if (response) return response.data;
};

export const markDocumentsAsPaid = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/paymentRequest/markDocumentsAsPaid`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getExpensesFinancialNodes = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/paymentRequest/financialNodes/expenses`,
    dispatch,
  });
  if (response) return response.data;
};

export const getPendingPayRoll = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/pendingPayRoll`,
    dispatch,
  });
  if (response) return response.data;
};

export const executePayouts = (dispatch: Dispatch) => {
  return useMutation({
    mutationKey: ['payouts', 'executePayouts'],
    mutationFn: async (
      data: ExecutePayoutsPayload,
    ): Promise<ExecutePayoutsResponse | undefined> => {
      const response = await requestHandler({
        method: 'post',
        url: `internal/payouts/execute`,
        dispatch,
        data,
      });
      if (response) return response.data;
    },
  });
};

export const getAllPayments = async (
  dispatch: Dispatch,
  query: string,
): Promise<GetAllPaymentsResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/payouts?${query}`,
    dispatch,
  });
  if (response) return response.data;
};
